/**
 * --------------------------------------------------------------------------
 * Public Util Api
 * --------------------------------------------------------------------------
 */

const Util = {

  /**
   * Retrouve le parent d'un élément selon une classe fournie (équivalent à closest)
   * @param {HTMLElement} element - L'élément enfant
   * @param {string} className - La classe parente
   *
   * @return {HTMLElement} - L'élément parent
   */
  findParentByClassName(element, className) {
    while ((element = element.parentElement) && !element.classList.contains(className)) { }
    return element;
  },

  /**
   * Retourne la position droite depuis le viewport d'un élément
   * @param {HTMLElement} element - L'élément ciblé
   *
   * @return {number} - position droite
   */
  getRightPosFromElement(element) {
    const { x, width } = element.getBoundingClientRect();
    return x + width;
  },

  /**
   * Check if an element is overflowing
   * @param {Element} element
   * @returns {boolean}
   */
   checkOverflow (element) {
    const currentOverflow = element.style.overflow;
    if (!currentOverflow || currentOverflow === "visible") {
      element.style.overflow = "hidden";
    }

    const isOverflowing = element.clientWidth < element.scrollWidth || element.clientHeight < element.scrollHeight;
    element.style.overflow = currentOverflow;

    return isOverflowing;
  }
};

export default Util;
